var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60156 50H39.9766C42.5645 50 44.6641 47.9004 44.6641 45.3125V4.6875C44.6641 2.09961 42.5645 0 39.9766 0H5.60156C3.01367 0 0.914062 2.09961 0.914062 4.6875V45.3125C0.914062 47.9004 3.01367 50 5.60156 50ZM2.47656 4.6875C2.47656 2.96484 3.87891 1.5625 5.60156 1.5625H39.9766C41.6992 1.5625 43.1016 2.96484 43.1016 4.6875V45.3125C43.1016 47.0352 41.6992 48.4375 39.9766 48.4375H5.60156C3.87891 48.4375 2.47656 47.0352 2.47656 45.3125V4.6875ZM18.1016 44.5312H27.4766C27.9068 44.5312 28.2578 44.1818 28.2578 43.75C28.2578 43.3182 27.9068 42.9688 27.4766 42.9688H18.1016C17.6713 42.9688 17.3203 43.3182 17.3203 43.75C17.3203 44.1818 17.6719 44.5312 18.1016 44.5312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.1855605a5fd12993583eeeae04f708dd.svg";
export { ForwardRef as ReactComponent };